import React from "react";
import { BOOK_IMAGE } from "../mock";

// Book cover using the actual book image
export default function BookCover({ className = "" }) {
  return (
    <div className={className}>
      <img
        src={BOOK_IMAGE}
        alt="The Mother Behind That Child by Rachelle Koulibaly"
        className="w-[320px] max-w-full object-contain drop-shadow-2xl transition-transform duration-500 hover:scale-[1.03]"
      />
    </div>
  );
}
